import React, { useEffect, useState } from "react"
import { IUnionStep, IQuery, IQueryBuilderContext, IStepValidationResponse, StepType, IDataSource, IStep } from "@types"
import { appendSchema, findMultipleSourcesByIds, getQueryUntilPreviousStep, getSchemaForSource, getSchemaForStep, getSelectedStepDetailsById, isDataSource, isSourceAvailableInQuery, registerStep, validateSource, validateSourceById, validateStep, validateStepNameAndId } from "@utils"
import { FormSection } from "@components/FormSection/FormSection"
import { MultipleSourcesSelectorInput } from "../SourceSelector/SourceSelectorInput"
import Icon from '@images/union.svg'
import { updateStep } from "../StepConfigUtils"

export function renderStep(context: IQueryBuilderContext, query: IQuery, onChange: (query: IQuery) => void, selectedStepId: string) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId)
    const _step: IUnionStep = Object.assign({}, step as IUnionStep)

    const [errors, setErrors] = useState<Record<string, string>>({})

    useEffect(() => {
        const { isValid, errors } = validateStep(query, step as IUnionStep)
        setErrors(errors)
    }, [step])

    const sources = findMultipleSourcesByIds(query, _step.sources)

    async function updateValue(updated: (IDataSource | IStep)[]) {
        let _query = { ...query }

        for (const source of updated) {
            if (isDataSource(source) && !isSourceAvailableInQuery(_query, source.id)) {
                _query.sources.push(source)
            }

            //since current step is not configured properly get query up to previous step to get the schema
            const tempQuery = getQueryUntilPreviousStep(_query, selectedStepId)
            const schema = await (isDataSource(source) ? getSchemaForSource : getSchemaForStep)(context, tempQuery, source.id)
            _query = appendSchema(_query, schema, source.id, true)
        }

        const _updQuery = updateStep(_query, selectedStepId, 'sources', [...updated.map(s => (s.id))])
        onChange(_updQuery)
    }

    return <React.Fragment>


        <FormSection
            label='Sources'
            error={errors?.sources}
        >
            <MultipleSourcesSelectorInput
                sources={sources}
                onChange={updated => { updateValue(updated) }}
                availableSources={[...previousSteps, ...selectedSources]}
                query={query}
            />
        </FormSection>

    </React.Fragment>
}

function validate(query: IQuery, step: IUnionStep): IStepValidationResponse {
    const errors: Record<string, string> = validateStepNameAndId(step);
    // validate sources
    if (!step?.sources || step?.sources?.length == 0) errors.sources = 'Atleast one source is required'
    else {
        const allSourceValid = step.sources.every(sourceId => validateSourceById(query, sourceId).isValid);
        if (!allSourceValid) errors.sources = 'One or more sources are invalid'
        else {
            const uniqueSources = new Set(step.sources);
            if (uniqueSources.size !== step.sources.length) {
                errors.sources = 'Duplicate sources are not allowed';
            }
        }
    }


    return { isValid: Object.keys(errors).length === 0, errors };
}

registerStep({
    type: StepType.Union,
    name: "Combine",
    description: "Combine multiple data sources together into one",
    icon: Icon,
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return { ...basicProps, sources: [previousSource] } as IUnionStep
    }
})